import React, { useEffect, useState, useContext } from "react";
import { StoreContext } from "../../../Store/Provider";
import { Bar, Chart } from "react-chartjs-2";

function BarStats(props) {
  const context = useContext(StoreContext);
  let lables = [];
  let values = [];
  let CarrierName = [];
  let width = 0;
  let max = 0;
  if (props.data) {
    props.data.length &&
      props.data.forEach((ele) => {
        lables.push(ele.CarrierCode);
        values.push(ele.ShipmentCount);
        CarrierName.push(ele.CarrierName);
      });
    width = 50 * (props.data.length + 1) + 100;
    max = Math.max(...values) + 0.1 * Math.max(...values);
  }

  const data = {
    labels: lables,
    CarrierName: CarrierName,

    datasets: [
      {
        label: "$",
        data: values,
        backgroundColor: `rgba(5, 74, 145)`,
      },
    ],
  };
  console.log(CarrierName);

  return (
    <div
      className="bardata"
      style={{ width: width, minWidth: "100%", overflowY: "hidden" }}
    >
      <Bar
        data={data}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false,
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  max: max,
                },
                gridLines: {
                  drawOnChartArea: false,
                },
                display: false,
              },
            ],
            xAxes: [
              {
                barPercentage: 0.6,
                maxBarThickness: 50,
                ticks: {
                  beginAtZero: true,
                  callback: function (value) {
                    if (value.length > 6) {
                      return value.substr(0, 6) + `..`;
                    } else {
                      return value;
                    }
                  },
                },
                gridLines: {
                  drawOnChartArea: false,
                },
              },
            ],
          },
          tooltips: {
            enabled: true,
            mode: "label",
            callbacks: {
              label: function (tooltipItem) {
                return "Shipment Count : " + tooltipItem.yLabel;
              },
              title: function (tooltipItems, data) {
                var idx = tooltipItems[0].index;
                console.log(data);
                return "Carrier Name : " + CarrierName[idx];
              },
            },
          },
          hover: {
            animationDuration: 0,
          },
          animation: {
            // "duration": 1,
            onComplete: function () {
              var chartInstance = this.chart,
                ctx = chartInstance.ctx;

              ctx.font = Chart.helpers.fontString(
                Chart.defaults.global.defaultFontSize,
                Chart.defaults.global.defaultFontStyle,
                Chart.defaults.global.defaultFontFamily
              );
              ctx.textAlign = "center";
              ctx.textBaseline = "bottom";

              this.data.datasets.forEach(function (dataset, i) {
                var meta = chartInstance.controller.getDatasetMeta(i);
                meta.data.forEach(function (bar, index) {
                  var data = dataset.data[index];
                  ctx.fillText(data, bar._model.x, bar._model.y);
                });
              });
            },
          },
        }}
      />
    </div>
  );
}

export default React.memo(BarStats);
